// src/components/dashboard/CrisisHighlight.jsx — v9.5.2
// Shows: incident label + date, revenue efficiency micro-trend.
// Removed: "CRISIS — CRITICAL", "Risk: CRITICAL", engine jargon.

import LossAttributionBlock from "../engine/LossAttributionBlock";

function isCrisis(s) { return s === "critical" || s === "red"; }

export default function CrisisHighlight({ riskHistory = [], loading }) {
  if (loading) {
    return <div className="skeleton" style={{ height: 72, borderRadius: "var(--radius)" }} />;
  }

  const crisis = [...riskHistory]
    .filter(d => isCrisis(d.risk_status))
    .sort((a, b) => (b.date ?? "").localeCompare(a.date ?? ""))[0] ?? null;

  if (!crisis) {
    return (
      <div style={{
        padding: "12px 18px", borderRadius: "var(--radius)",
        background: "var(--bg-card)", border: "1px solid var(--border-subtle)",
        fontFamily: "var(--font-mono)", fontSize: 12, color: "var(--success)",
      }}>
        ✓ No crisis events detected in history
      </div>
    );
  }

  const raw    = Number(crisis.roi ?? crisis.roi_raw ?? 0);
  const roiPct = Math.abs(raw) < 10 ? raw * 100 : raw;
  const roiStr = `${roiPct > 0 ? "+" : ""}${roiPct.toFixed(1)}%`;

  return (
    <div style={{
      padding: "14px 18px", borderRadius: "var(--radius)",
      background: "var(--danger-bg)", border: "1px solid var(--danger-border)",
    }}>
      {/* Header: incident label + date */}
      <div style={{
        display: "flex", alignItems: "center",
        justifyContent: "space-between", marginBottom: 12,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{
            width: 8, height: 8, borderRadius: "50%",
            background: "var(--danger)", boxShadow: "0 0 8px var(--danger)", flexShrink: 0,
          }} />
          <span style={{
            fontFamily: "var(--font-mono)", fontSize: 10, fontWeight: 700,
            letterSpacing: "0.12em", color: "var(--danger)", textTransform: "uppercase",
          }}>
            Performance incident
          </span>
        </div>
        <span style={{ fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--text-muted)" }}>
          {crisis.date}
        </span>
      </div>

      {/* Revenue efficiency micro-trend */}
      <div style={{ display: "flex", alignItems: "baseline", gap: 8, marginBottom: 8 }}>
        <span style={{
          fontFamily: "var(--font-mono)", fontSize: 9, letterSpacing: "0.1em",
          textTransform: "uppercase", color: "var(--text-muted)", flexShrink: 0,
        }}>
          Revenue efficiency dropped to
        </span>
        <span style={{
          fontFamily: "var(--font-mono)", fontSize: 18, fontWeight: 700,
          color: roiPct < 0 ? "var(--danger)" : "var(--warning)",
        }}>
          {roiStr}
        </span>
      </div>

      {/* Root cause attribution */}
      <LossAttributionBlock
        reasons={[]}
        risk_status={crisis.risk_status}
        compact={false}
      />

      <div style={{
        marginTop: 8, paddingTop: 8, borderTop: "1px solid var(--danger-border)",
        fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--text-muted)",
      }}>
        Performance instability detected in campaign data.
      </div>
    </div>
  );
}
